import { getLangFromText } from '@belong/type-utils';
import type { Entry, ICON_NAMES, ILink } from '@belong/types';
import { parseLinkData } from '../../helpers/parseLinkData';

export interface IEntryLink {
  key?: string;
  a11yLabel?: string;
  hash?: string;
  icon?: ICON_NAMES;
  isFootnoteLink?: boolean;
  label: string;
  shouldOpenInNewTab?: boolean;
  url?: Entry<{ url: string }>;
  variant: string;
}

export const FLink = ({ fields }: Entry<IEntryLink>): ILink => {
  const { a11yLabel, hash, icon, isFootnoteLink, label, shouldOpenInNewTab, url, variant } = fields;
  const lang = getLangFromText(label);

  const result: ILink = {
    label,
    children: label,
    variant: variant.toLowerCase(),
    a11yLabel,
    isFootnoteLink,
    icon,
    ...(url
      ? parseLinkData({
          ...url,
          hash
        })
      : {}),
    ...(lang ? { lang } : {})
  };

  if (shouldOpenInNewTab) {
    result.target = '_blank';
  }

  return result;
};
